import script from "./AnimatedEyes.vue?vue&type=script&lang=ts&setup=true"
export * from "./AnimatedEyes.vue?vue&type=script&lang=ts&setup=true"

import "./AnimatedEyes.vue?vue&type=style&index=0&id=0a7b29a7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a7b29a7"]])

export default __exports__